import { registerPlugin } from '@capacitor/core';

export interface SafeAreaInsets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface SafeAreaPlugin {
  getInsets(): Promise<SafeAreaInsets>;
}

const SafeArea = registerPlugin<SafeAreaPlugin>('SafeArea', {
  web: () => ({
    async getInsets() {
      // Web: sem safe area
      return { top: 0, bottom: 0, left: 0, right: 0 };
    }
  })
});

export default SafeArea;
